import styled from 'styled-components';

const MyDiv = styled.div`
  .chart-container {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  }

  .donut-chart {
    width: 120px;
    height: 100px;
  }

  .legend-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
    max-height: 125px; 
    overflow-y: auto;
    padding-right: 6px;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.3s ease-in-out;
  }

  .legend-list:hover {
    scrollbar-color: #a0aec0 #f1f1f1;
  }

  .legend-list::-webkit-scrollbar {
    width: 6px;
  }

  .legend-list::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 12px;
    transition: background 0.3s ease-in-out;
  }

  .legend-list:hover::-webkit-scrollbar-thumb {
    background: #a0aec0;
  }

  .legend-list::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 12px;
  }

  .legend-row {
    width: 100%;
  }

  .color-box {
    width: 12px;
    height: 12px;
    border-radius: 2px;
  }
    
`;

export default MyDiv;
